import { useEffect } from "react";
import { startThuthiTheme } from "@thuthi/web-shared/theme";

/**
 * 다크 모드는 thuthi 전체 설정(.thuthi.kr 쿠키 thuthi_theme)을 따른다 — 토글은 홈 웹에만 있다.
 * (예전 ntfy 자체 설정 prefs.theme 은 더 이상 쓰지 않는다. index.html 의 첫 페인트 스크립트가 같은 쿠키를 읽는다.)
 */
export const useAppDarkMode = () => {
  useEffect(() => startThuthiTheme(), []);
};

export default useAppDarkMode;
